export default __webpack_public_path__ + "assets/add5dff66f73b0623186e5f3380becf5.svg";